/**
 * 数据接口请求
 */
import axios from 'axios'
import qs from 'qs';

import {} from 'antd';

var base;
var goUrl;

if(document.domain === 'admin-yun.colourlife.com'){
    base = 'https://adminbackend-yun.colourlife.com';
    goUrl='https://admin-yun.colourlife.com';
}else if(document.domain === 'admin-yunbeta.colourlife.com'){
    base = 'https://adminbackend-yunbeta.colourlife.com';
    goUrl='https://admin-yunbeta.colourlife.com';
}else{
    base = 'https://adminbackend-yuntest.colourlife.com';
    goUrl='https://admin-yuntest.colourlife.com';
}

let formData=axios.create({
    headers: { "Content-Type": "multipart/form-data" }
 })

//请求拦截
axios.interceptors.request.use(  
    config => {  

        return config;

    },function(error){  

        return Promise.reject(error);

    }  
) 

//响应拦截
axios.interceptors.response.use(function (response) { 

    if(response.data.code == 20005){

        window.location.href = `${goUrl}/#/login`;

    }

    return response; 
}, function (error) {  

    return Promise.reject(error)  
}) 

// 获取二维码信息
export const getQrCodeInfo = params => { return axios.post(`${base}/login/qrCode`, qs.stringify( params )).then(res => res.data) }

// 获取跳转地址
export const getRedirectUrl = params => { return axios.post(`${base}/login/qrCode/scanResult`, qs.stringify( params )).then(res => res.data) }

// 账号密码登录
export const login = params => { return axios.post(`${base}/login/username`, qs.stringify( params )).then(res => res.data) }

// 获取token
export const getToken = params => { return axios.get(`${base}/login/token`, {params:params}).then(res => res.data) }

// 获取跳转登录地址
export const getUrl = params => { return axios.get(`${base}/unify/login`, {params:params}).then(res => res.data) }

// 获取用户信息及菜单列表
export const getUserInfo = params => { return axios.get(`${base}/menu/userInfo`, {params:params}).then(res => res.data) }

// 菜单管理所有接口

//新增菜单
export const addMenu = params => { return axios.post(`${base}/menu/add`, qs.stringify( params )).then(res => res.data) }

//上传图片
export const uploadImg = params => { return formData.post(`${base}/image/upload`, params ).then(res => res.data) }

//修改菜单
export const updateMenu = params => { return axios.post(`${base}/menu/edit`, qs.stringify( params )).then(res => res.data) }

//启用，禁用菜单
export const forbidMenu = params => { return axios.post(`${base}/menu/forbid`, qs.stringify( params )).then(res => res.data) }

//删除菜单
export const deleteMenu = params => { return axios.post(`${base}/menu/delete`, qs.stringify( params )).then(res => res.data) }

//菜单搜索列表
export const getMenuList = params => { return axios.get(`${base}/menu/list`, {params:params}).then(res => res.data) }

// 角色管理所有接口

//新增角色
export const addRole = params => { return axios.post(`${base}/role/add`, qs.stringify( params )).then(res => res.data) }

//修改角色
export const updateRole = params => { return axios.post(`${base}/role/edit`, qs.stringify( params )).then(res => res.data) }

//删除角色
export const deleteRole = params => { return axios.post(`${base}/role/delete`, qs.stringify( params )).then(res => res.data) }

//角色搜索列表
export const getRoleList = params => { return axios.get(`${base}/role/list`, {params:params}).then(res => res.data) }

//角色关联员工列表查询
export const getRoleUserList = params => { return axios.get(`${base}/role/user/list`, {params:params}).then(res => res.data) }

//搜索员工
export const fetchUser = params => { return axios.get(`${base}/org/user/search`, {params:params}).then(res => res.data) }

//新增员工
export const addUser = params => { return axios.post(`${base}/role/user/add`, qs.stringify( params )).then(res => res.data) }

//组织架构列表
export const getOrg = params => { return axios.get(`${base}/org/search`, {params:params}).then(res => res.data) }

//修改员工
export const updateUser = params => { return axios.post(`${base}/role/user/update`, qs.stringify( params )).then(res => res.data) }

//删除员工
export const deleteUser = params => { return axios.post(`${base}/role/user/delete`, qs.stringify( params )).then(res => res.data) }

//角色权限一级列表查询
export const getRoleMenu = params => { return axios.get(`${base}/role/menu/list`, {params:params}).then(res => res.data) }

//角色权限一级菜单子菜单列表查询
export const getRoleMenuChild = params => { return axios.get(`${base}/role/menu/child/list`, {params:params}).then(res => res.data) }

//角色权限列表更新
export const updateRoleMenu = params => { return axios.post(`${base}/role/menu/update`, qs.stringify( params )).then(res => res.data) }

// 按岗位授权所有接口

//岗位搜索
export const fetchJob = params => { return axios.get(`${base}/jobType/search`, {params:params}).then(res => res.data) }

//新增岗位授权
export const addJob = params => { return axios.post(`${base}/role/jobType/add`, qs.stringify( params )).then(res => res.data) }

//角色下授权岗位删除
export const deleteJob = params => { return axios.post(`${base}/role/jobType/delete`, qs.stringify( params )).then(res => res.data) }

//角色下授权岗位列表
export const getJobList = params => { return axios.get(`${base}/role/jobType/list`, {params:params}).then(res => res.data) }

//角色下授权岗位员工列表
export const getJobUserList = params => { return axios.get(`${base}/role/jobType/user/list`, {params:params}).then(res => res.data) }

// 日志管理所有接口

// 日志列表
export const getLogList = params => { return axios.get(`${base}/log/list`, {params:params}).then(res => res.data) }

// 配置列表
export const getConfigList = params => { return axios.get(`${base}/log/config/list`, {params:params}).then(res => res.data) }

// 编辑列表
export const getConfigEdit = params => { return axios.post(`${base}/log/config/edit`, qs.stringify( params )).then(res => res.data) }

// 删除列表
export const getConfigDel = params => { return axios.post(`${base}/log/config/del`, qs.stringify( params )).then(res => res.data) }

export const baseUrl = goUrl;

export const baseBackendUrl = base;

export default base


// WEBPACK FOOTER //
// ./src/apis/api.js